<ng-template #template>
  <div>
    <svg *ngIf="question.iconDragElement" [class]="question.cssClasses.dragElementDecorator">
      <use [attr.xlink:href]="question.iconDragElement"></use>
    </svg>
    <span *ngIf="!question.iconDragElement" data-bind="css: question.cssClasses.iconDrag"></span>
  </div>
</ng-template>